import { firebaseConfig } from "@/services/firebase/config"

export default function EnvironmentBanner() {
  const isSandbox = firebaseConfig.projectId === "onreel-sandbox"

  if (!isSandbox) {
    return null
  }

  return (
    <div className="pointer-events-none fixed right-0 top-0 z-50 overflow-hidden h-24 w-24">
      {/* Ribbon triangle */}
      <div className="absolute right-[-34px] top-[14px] w-[120px] rotate-45 bg-amber-500/85 py-1 text-center text-[10px] font-bold uppercase tracking-wider text-white shadow-sm">
        Sandbox
      </div>
    </div>
  )
}
